module.exports = __webpack_public_path__ + "static/media/artist_08.03ade0d3.png";